
import React, {useState, useContext, useEffect} from 'react';
import { Col, Row, Form, Card, Modal, Table, Button } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import Preloader from '../../components/Preloader/Preloader';
//import BarQrScanner from '../barcodeScan/BarQrScanner';
import {Helmet} from 'react-helmet-async';

const config = require('../../config.json');

// Modern UI styles with improved responsiveness
const issueBookModernStyles = `
  .issuebook-section {
    background: linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%);
    min-height: 100vh;
    padding: 40px 0 60px 0;
    font-family: Inter, Segoe UI, Arial, sans-serif;
  }
  .issuebook-card {
    border-radius: 18px !important;
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.08);
    border: none !important;
    margin-bottom: 2rem;
    background: #fff !important;
    transition: box-shadow 0.2s;
  }
  .issuebook-section-title {
    font-size: 2rem;
    font-weight: 700;
    color: #2a3659;
    margin-bottom: 1.5rem;
    text-align: center;
    letter-spacing: 0.5px;
  }
  .issuebook-form-label {
    font-weight: 600;
    color: #2a3659;
    margin-bottom: 0.3rem;
  }
  .issuebook-btn {
    background: linear-gradient(90deg, #4f8cff 0%, #6ed0fa 100%);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 28px;
    font-size: 1.08rem;
    font-weight: 600;
    box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.07);
    transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
    margin-top: 10px;
    width: 100%;
    max-width: 320px;
  }
  .issuebook-btn:hover, .issuebook-btn:focus {
    background: linear-gradient(90deg,  #063547 60%, #7ee8fa 100%);
    color: #fff;
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.13);
  }
  .issuebook-table th, .issuebook-table td {
    vertical-align: middle !important;
    text-align: center;
    font-size: 1rem;
    word-break: break-word;
    padding: 0.5rem 0.3rem;
  }
  .issuebook-table th {
    background: #e3eafc !important;
    color: #2a3659;
    font-weight: 700;
  }
  .issuebook-table tr {
    background: #fff !important;
  }
  .issuebook-table img {
    border-radius: 50%;
    border: 2px solid #e3eafc;
    width: 2.2rem;
    height: 2.2rem;
    object-fit: cover;
  }
  @media (max-width: 1200px) {
    .issuebook-card {
      margin-bottom: 1.2rem;
    }
    .issuebook-section {
      padding: 20px 0 30px 0;
    }
    .issuebook-section-title {
      font-size: 1.3rem;
    }
    .issuebook-btn {
      font-size: 1rem;
      padding: 8px 18px;
    }
  }
  @media (max-width: 900px) {
    .issuebook-section {
      padding: 10px 0 20px 0;
    }
    .issuebook-section-title {
      font-size: 1.1rem;
    }
    .issuebook-card {
      border-radius: 12px !important;
      margin-bottom: 1rem;
      box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.08);
    }
    .issuebook-btn {
      font-size: 0.98rem;
      padding: 8px 10px;
      border-radius: 8px;
      margin-top: 8px;
    }
    .issuebook-table th, .issuebook-table td {
      font-size: 0.95rem;
      padding: 0.4rem 0.2rem;
    }
  }
  @media (max-width: 600px) {
    .issuebook-section {
      padding: 4px 0 10px 0;
    }
    .issuebook-section-title {
      font-size: 1rem;
      margin-bottom: 0.7rem;
    }
    .issuebook-card {
      border-radius: 8px !important;
      margin-bottom: 0.7rem;
      box-shadow: 0 1px 4px 0 rgba(44, 62, 80, 0.08);
      padding: 0.5rem 0.2rem;
    }
    .issuebook-btn {
      font-size: 0.95rem;
      padding: 7px 6px;
      border-radius: 7px;
      margin-top: 6px;
      width: 100%;
      max-width: 100%;
    }
    .issuebook-table th, .issuebook-table td {
      font-size: 0.9rem;
      padding: 0.3rem 0.1rem;
    }
    .issuebook-table img {
      width: 1.7rem;
      height: 1.7rem;
    }
    .container, .section {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
`;

export default function IssueBooks() {
    const { validateLogin, loggedUser, handleImageError, generateDate, generateReturnDate,generateAccessionNo, generateUUIDNo } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();
    const [searchBook, setSearchBook] = useState({type:'AccessionNo', value:''});
    const [searchUser, setSearchUser] = useState({type:'PhoneNo', value:''});
    const [bookResult, setBookResult] = useState([]);
    const [userResult, setUserResult] = useState([]);
    const [bookSelect, setBookSelect]= useState();
    const [userSelect, setUserSelect]= useState();
    const [loaded, setLoaded] = useState(true);
    //const [activateScanner, setActivateScanner]= useState(false);
    const [issuedBooks, setIssuedBooks]=useState([]);
    const [show, setShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('')
    const refBook = React.useRef([]);
    const refUser = React.useRef([]);
    const [userListShow, setUserListShow] = useState(false);
    const [bookListShow, setBookListShow] = useState(false);


    useEffect(()=>{
      if(!loggedUser.isAuthenticated){
        validateLogin();
      }else{
          handleReset();
      }
    },[loggedUser])

    const handleBookSearch=async(event)=>{
        event.preventDefault();
        //console.log("search book : ", searchBook);
        try{
          UncheckedBooks();
            setLoaded(false);
            //setDispMsg('');
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const clientID="AKLibrary";
            const searchValue = searchBook.value;
            const searchTopic = searchBook.type;
            await axios.get(`${config.api.invokeUrl}/search/books?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            headers: {
              Authorization: idToken,
              'x-api-key':config.api.key
            }
          }).then(async(response) => {
            setBookSelect();
           console.log("response : ", response.data);
           //setDispMsg(response.data.length+' - Books Found');
           if(response.data.length===1){
            setBookResult(response.data);
            setBookSelect(response.data[0]);
            UncheckedBooks();
            enqueueSnackbar(response.data.length + " - Books found!",{variant:'success'}); 
            setLoaded(true);  
          }else if(response.data.length<=0){
            enqueueSnackbar(response.data.length + " - Books found!",{variant:'success'}); 
          }else{
            setBookListShow(true);
            setBookResult(response.data);
          }
          setLoaded(true);
           /* setBookResult(response.data);
            UncheckedBooks();
            setBookSelect();
            enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'}); 
            setLoaded(true);*/
        }).catch((error)=>{
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })
        }catch(error){
            //console.log("error:", error);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        }
    

    }

    const handleSortKey =async(event, value)=>{
      event.preventDefault();
      console.log("clicked");
      /*if(value==="AccessionNo"){
        const tempOrginalValue=bookResult;
        setBookResult([]);
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.accessionNo - b.accessionNo;});
        console.log("Sorted AccessionNo Array ", sortedOptionArray);
        await setBookResult(sortedOptionArray);
      }else if(value==="BookTitle"){
        const tempOrginalValue=bookResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.bookTitle - b.bookTitle;});
        console.log("Sorted Book Array ", sortedOptionArray);
        await setBookResult(sortedOptionArray);
      }else if(value==="BookingDate"){
        var tempOrginalValue=bookResult;
        //const tempFilterValue=tempOrginalValue.sort((a,b)=>)
        var sortedOptionArray = tempOrginalValue.sort((a, b) => {return a.bookedOn - b.bookedOn;});
        tempOrginalValue.sort((a, b) => (a.name - b.name ? 1 : -1));
    
        console.log("Sorted Book Array ", tempOrginalValue);
        await setBookResult(sortedOptionArray);
      }*/
      
    }

    const handleUserSearch=async(event)=>{
        event.preventDefault();
        //console.log("user details : ", searchUser);
        try{
            //UncheckedUsers();
            if(searchUser.value===""){
              enqueueSnackbar("Search Value is empty Enter the search input and then hit Search button!",{variant:'warning'}); 
            }else{
              setLoaded(false);
              const searchValue=searchUser.value;
              const searchTopic=searchUser.type;
            await axios.get(`${config.api.invokeUrl}/users/search?fetchKey=${searchValue}&fetchOption=${searchTopic}`, {
              headers: {
                //Authorization: idToken,
                //'x-api-key':config.userapi.key
              }
            }).then(async(response) => {
              console.log("Res : ", response.data);
              setUserSelect(null);
              if(response.data.length===1){
                setUserResult(response.data);
                UncheckedUsers();
                setUserSelect(response.data[0]);
                getBooks(response.data[0].phoneno);
                enqueueSnackbar(response.data.length + " - student's records found!",{variant:'success'}); 
                setLoaded(true);  
              }else if(response.data.length<=0){
                enqueueSnackbar(response.data.length + " - student's records found!",{variant:'success'}); 
              }else{
                setUserListShow(true);
                setUserResult(response.data);
              }
              setLoaded(true);
          }).catch((error)=>{
            //console.log("Error :", error);
            enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
          setLoaded(true);
        })
       // getBooks();
       /* const clientID="VJCollege";
        //console.log("search value :", searchValue);
        const tempTopic="UserID";
       // const { idToken1 } = (await fetchAuthSession()).tokens ?? {};
        await axios.get(`${config.api.invokeURL}/vjlibrary/issue?fetchKey=${searchValue}&fetchOption=${tempTopic}&clientID=${clientID}`, {
          headers: {
            Authorization: idToken,
            'x-api-key':config.api.key
          }
        }).then(async(response) => {
         console.log("response : ", response.data);
         //setDispMsg(response.data.length+' - Books Found');
          setIssuedBooks(response.data);
          enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'}); 
          setLoaded(true);
      }).catch((error)=>{
        console.log("Error1 :", error);
        enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
    })*/
  }
  }catch(error){
    //console.log("Error2 :", error);
    enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
    setLoaded(true);
  }
}

const getBooks=async(searchValue)=>{
  try{
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    const clientID="AKLibrary";
    const tempTopic="UserID";
    //const searchValue=searchUser.value;
    //await axios.get(`${config.api.invokeURL}/vjlibrary/issue?fetchKey=${searchValue}&fetchOption=${tempTopic}&clientID=${clientID}`, {
    await axios.get(`${config.api.invokeUrl}/issue?fetchKey=${searchValue}&fetchOption=${tempTopic}&clientID=${clientID}`, {
      headers: {
      //  Authorization: idToken,
        'x-api-key':config.api.key
      }
    }).then(async(response) => {
    // console.log("response : ", response.data);
     //setDispMsg(response.data.length+' - Books Found');
      setIssuedBooks(response.data);
      //enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'}); 
      setLoaded(true);
  }).catch((error)=>{
   // console.log("Error1 :", error);
    enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
    setLoaded(true);
})
  }catch(error){
    enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
    setLoaded(true);
  }
}

    const handleBookSelection=(event, item)=>{
        //console.log("item:",item);
        setBookSelect(item);
    }

    const handleUserSelection=(event, item)=>{
        //console.log("event:",item);
        setUserSelect(item);
    }

    const handleBookIssue=async(event)=>{
        event.preventDefault();
        try{
            if(!bookSelect){
              enqueueSnackbar("Select the Book!",{variant : 'info'});
            }else if(!userSelect){
              enqueueSnackbar("Select the User!",{variant : 'info'});
            }else if(issuedBooks.length>=20){
              enqueueSnackbar("20 books limit reached!",{variant : 'info'});
            }else if(bookSelect.Book_Status==="Available"){
                setLoaded(false);
                const todayDate=await generateDate();
                const returnDate=await generateReturnDate(30);
                //const tbookingid=await generateAccessionNo();
                const tbookingid=await generateUUIDNo();
                const { idToken } = (await fetchAuthSession()).tokens ?? {};
                const params={
                  clientID:loggedUser.family_name,
                  issueID:"BK-"+tbookingid,
                  accessionNo:bookSelect.Accession_No,
                  bookAuthor:bookSelect.Book_Author,
                  bookClassificationNo:bookSelect.Book_Classification_No,
                  bookCategory:bookSelect.Book_Classification_No,
                  bookEdition:bookSelect.bookEdition,
                  bookPages:bookSelect.bookPages,
                  bookPrice:bookSelect.bookPrice,
                  bookPublishYear:bookSelect.Publishing_Year,
                  bookPublisherName:bookSelect.Book_Publisher,
                  bookScope:bookSelect.Book_Scope,
                  bookStatus:"Issued",
                  bookTitle:bookSelect.Book_Title,
                  bookedOn:todayDate,
                  bookedfor:userSelect.userfullname,
                  userID:userSelect.phoneno,
                  userEmailID:userSelect.emailid,
                  bookedFrom:todayDate,
                  bookedTo:returnDate,
                  updatedBy:loggedUser.name,
                  updatedOn:todayDate
                }; 
                console.log("Params :", params);
                //setLoaded(true);

                //setLoaded(true);
                await axios.post(`${config.api.invokeUrl}/issue`,params, {  
                  headers: {
                    Authorization: idToken,
                    'x-api-key':config.api.key
                  }
                }).then(async(response) => {
                  getBooks(userSelect.phoneno);
                  const { idToken } = (await fetchAuthSession()).tokens ?? {};
                  const tempeid=['rjosephxavier@yahoo.com','rjosephxavier@gmail.com'];
                  const eamilParams={
                    accessionNo:bookSelect.Accession_No,
                    bookedfor:userSelect.userfullname,
                    bookTitle:bookSelect.Book_Title,
                    bookedFrom:todayDate,
                    bookedTo:returnDate,
                    bookAuthor:bookSelect.Book_Author,
                    userEmailID:userSelect.emailid
                    //userEmailID:tempeid
                  };
                  console.log("Email Params :", eamilParams);
                  axios.post(`${config.api.invokeUrl}/notification`,eamilParams, {  
                    headers: {
                      Authorization: idToken,
                      'x-api-key':config.api.key
                    }
                  });
                  enqueueSnackbar("Book '" + bookSelect.Accession_No + "' successfully assigned to '" + userSelect.userfullname +"'",{variant:'success'});
                  //getBooks();
                  handleReset();
                  setLoaded(true)
              }).catch((error)=>{
              enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
              setLoaded(true);
              window.scrollTo(0,0);
            })
            }else{
              enqueueSnackbar("This book is not available - " + bookSelect.Accession_No,{variant:'info'});
            }
        }catch(error){
            //console.log("Error : ", error);
            setLoaded(true);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        }
    }

    const handleReset=()=>{
      setSearchBook({type:'AccessionNo', value:''});
      //setSearchUser({type:'RegistrationID', value:''});
      setBookResult([]);
      //setUserResult([]);
      setBookSelect();
      //setUserSelect();  
    }

    const handleClose = () => setShow(false);

    const handleUserListClose = () => setUserListShow(false);

    const handleBookListClose = () => setBookListShow(false);

    const handleShow = () => {
      //event.preventDefault();
      setShow(true);
      setModalTitle("Book's Issued");
    }

    const UncheckedBooks = () => {
      //console.log(ref.current.length)
      //console.log("ref :", ref);
      for (let i = 0; i < refBook.current.length; i++) {
        if(refBook.current[i]!==null){
          refBook.current[i].checked = false;
        }
      }
    }

    const UncheckedUsers = () => {
     // console.log(ref.current.length)
     // console.log("ref :", refUser);
      for (let i = 0; i < refUser.current.length; i++) {
        if(refUser.current[i]!==null){
          refUser.current[i].checked = false;
        }
      }
    }

    const handleFinalizeUser=()=>{
      //console.log("user select :", userSelect);
      if(!userSelect){
        enqueueSnackbar("Select a user first",{variant:'info'}); 
      }else{
        handleUserListClose();
        getBooks(userSelect.phoneno);
      }
    }

    const handleFinalizeBook=()=>{
      //console.log("user select :", userSelect);
      if(!bookSelect){
        enqueueSnackbar("Select a book first",{variant:'info'}); 
      }else{
        handleBookListClose();
       // getBooks(userSelect.registrationNo);
      }
    }

  return (
    <div className="issuebook-section">
      <style>{issueBookModernStyles}</style>
      <Helmet>
        <title>Issue Books - Inigo Library - Arul Kadal - Chennai</title>
        <meta name="description" content="Issue Books - Inigo Library - Arul Kadal - Chennai" />
        <meta name="keywords" content="Issue Books - Inigo Library - Arul Kadal - Chennai" />
      </Helmet>

      {/* View Books Modal */}
      <Modal show={show} onHide={handleClose} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {issuedBooks.length > 0 ? (
              <Table striped bordered hover responsive className="issuebook-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Accession No <i className="fa fa-sort" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i></th>
                    <th>Book Title <i className="fa fa-sort" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i></th>
                    <th>Author <i className="fa fa-sort" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i></th>
                    <th>Call No <i className="fa fa-sort" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i></th>
                    <th>Issued To <i className="fa fa-sort" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i></th>
                    <th>Booking Date <i className="fa fa-sort" aria-hidden="true" onClick={event => handleSortKey(event, "BookingDate")}></i></th>
                    <th>Return Date <i className="fa fa-sort" aria-hidden="true" onClick={event => handleSortKey(event, "BookTitle")}></i></th>
                  </tr>
                </thead>
                <tbody>
                  {issuedBooks.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.accessionNo}</td>
                      <td>{item.bookTitle}</td>
                      <td>{item.bookAuthor}</td>
                      <td>{item.bookClassificationNo}</td>
                      <td>{item.bookedfor}</td>
                      <td>{item.bookedOn}</td>
                      <td>{item.bookedTo}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : null}
          </div>
        </Modal.Body>
      </Modal>

      {/* List Users Modal */}
      <Modal show={userListShow} onHide={handleUserListClose} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>User List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {userResult.length > 0 ? (
              <Table striped bordered hover responsive className="issuebook-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>User Name</th>
                    <th>Phone No</th>
                    <th>Email ID</th>
                    <th>Account Status</th>
                  </tr>
                </thead>
                <tbody>
                  {userResult.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <Form.Check
                          inline
                          type='radio'
                          name="userGroup"
                          id={`userGroup-${index}`}
                          checked={userSelect && userSelect.phoneno === item.phoneno}
                          onChange={event => handleUserSelection(event, item)}
                          ref={element => { refUser.current[index] = element }}
                        />
                      </td>
                      <td>
                        <img id="profile" src={`${config.s3.profileUrl}${item.applicationNo}/${item.avatar}`}
                          onError={handleImageError}
                          alt="Profile" style={{ width: "2.5rem", height: "2.5rem", borderRadius: "50%" }} />
                        {item.userfullname}
                      </td>
                      <td>{item.phoneno}</td>
                      <td>{item.emailid}</td>
                      <td>{item.account_status}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : null}
          </div>
          <div className="mt-3 text-center">
            <button className='issuebook-btn' onClick={event => handleFinalizeUser(event)}>Select</button>
          </div>
        </Modal.Body>
      </Modal>

      {/* List Books Modal */}
      <Modal show={bookListShow} onHide={handleBookListClose} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>Book List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {bookResult.length > 0 ? (
            <Table striped bordered hover responsive className="issuebook-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Accession No</th>
                  <th>Book Title</th>
                  <th>Author</th>
                  <th>Call No</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {bookResult.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Check
                        inline
                        type='radio'
                        name="bookGroup"
                        id={`bookGroup-${index}`}
                        checked={bookSelect && bookSelect.accessionNo === item.accessionNo}
                        onChange={event => handleBookSelection(event, item)}
                        ref={element => { refBook.current[index] = element }}
                      />
                    </td>
                    <td>{item.accessionNo}</td>
                    <td>{item.bookTitle}</td>
                    <td>{item.bookAuthor}</td>
                    <td>{item.bookClassificationNo}</td>
                    <td>{item.bookStatus}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : null}
          <div className="mt-3 text-center">
            <button className='issuebook-btn' onClick={event => handleFinalizeBook(event)}>Select</button>
          </div>
        </Modal.Body>
      </Modal>

      <div className='container'>
        <div className="section">
          {!loaded && <Preloader show={loaded ? false : true} />}
          <div className="issuebook-section-title">Issue Book's</div>

          {/* User Details */}
          <Card className="issuebook-card">
            <Card.Body>
              <Form>
                <Row>
                  <Col lg={3} className="mb-3">
                    <Form.Group id="firstName">
                      <Form.Label className="issuebook-form-label">Search Type</Form.Label>
                      <Form.Select size="lg" style={{ fontSize: 16, borderRadius: 10, padding: 8, width: "100%" }}
                        value={searchUser.type}
                        onChange={event => { setSearchUser({ ...searchUser, type: event.target.value }) }}
                      >
                        <option value="UserName">UserName</option>
                        <option value="PhoneNo">Phone No</option>
                        <option value="Email">Email ID</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={6} className="mb-3">
                    <Form.Group id="middleName">
                      <Form.Label className="issuebook-form-label">Search Details</Form.Label>
                      <Form.Control required type="text" placeholder="Enter the search details..."
                        value={searchUser.value}
                        onChange={event => { setSearchUser({ ...searchUser, value: event.target.value }) }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={3} className="mb-1 d-flex align-items-end">
                    <button className='issuebook-btn w-100' onClick={event => handleUserSearch(event)}>Search User</button>
                  </Col>
                </Row>
              </Form>
              {userResult.length > 0 ? (
                <Table striped bordered hover responsive className="issuebook-table mt-4">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Phone No</th>
                      <th>User Name</th>
                      <th>Books Issued</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userSelect && (
                      <tr>
                        <td>
                          <Form.Check
                            inline
                            type='radio'
                            name="userGroup"
                            id="userGroup"
                            checked
                          />
                        </td>
                        <td>{userSelect.phoneno}</td>
                        <td>
                          <img id="profile" src={`${config.s3.profileUrl}${userSelect.applicationNo}/${userSelect.avatar}`}
                            onError={handleImageError}
                            alt="Profile" style={{ width: "2.5rem", height: "2.5rem", borderRadius: "50%" }} />
                          {userSelect.userfullname}
                        </td>
                        <td>{issuedBooks.length}</td>
                        <td><i className="fa fa-eye" aria-hidden="true" onClick={event => handleShow()}></i></td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              ) : null}
            </Card.Body>
          </Card>

          {/* Book Details */}
          <Card className="issuebook-card">
            <Card.Body>
              <Form>
                <Row>
                  <Col lg={3} className="mb-3">
                    <Form.Group id="firstName">
                      <Form.Label className="issuebook-form-label">Search Type</Form.Label>
                      <Form.Select size="lg" style={{ fontSize: 16, borderRadius: 10, padding: 8, width: "100%" }}
                        value={searchBook.type}
                        onChange={event => { setSearchBook({ ...searchBook, type: event.target.value }) }}
                      >
                        <option value="AccessionNo">Book ID</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={6} className="mb-3">
                    <Form.Group id="middleName">
                      <Form.Label className="issuebook-form-label">Search Details</Form.Label>
                      <Form.Control required type="text" placeholder="Enter the search details..."
                        value={searchBook.value}
                        onChange={event => { setSearchBook({ ...searchBook, value: event.target.value }) }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={3} className="mb-1 d-flex align-items-end">
                    <button className='issuebook-btn w-100' onClick={event => handleBookSearch(event)}>Search Book</button>
                  </Col>
                </Row>
              </Form>
              {bookResult.length > 0 ? (
                <Table striped bordered hover responsive className="issuebook-table mt-4">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Accession No</th>
                      <th>Book Title</th>
                      <th>Author</th>
                      <th>Call No</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookSelect && (
                      <tr>
                        <td>
                          <Form.Check
                            inline
                            type='radio'
                            name="bookGroup"
                            id="bookGroup"
                            checked
                          />
                        </td>
                        <td>{bookSelect.Accession_No}</td>
                        <td>{bookSelect.Book_Title}</td>
                        <td>{bookSelect.Book_Author}</td>
                        <td>{bookSelect.Book_Classification_No}</td>
                        <td>{bookSelect.Book_Status}</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              ) : null}
            </Card.Body>
          </Card>

          <div className="mt-3 text-center">
            <button className='issuebook-btn' onClick={event => handleBookIssue(event)}>Issue Books</button>
          </div>
        </div>
      </div>
    </div>
  );
}
